import { useSearchParams } from 'react-router-dom'

import {
  Box,
  Button,
  Card,
  EnhancedDimension,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'
import { PerformanceReviewOverviewPendingEvaluationsTaskFragment } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { MyReviews } from 'modules/performance_process/components/overview/myReviews'

interface Props {
  reviewProcess: PerformanceReviewOverviewPendingEvaluationsTaskFragment
  minWidth?: EnhancedDimension
}

export const PendingEvaluationsTask = ({ reviewProcess, minWidth }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const isSidepanelOpen = searchParams.get('myReviewsPanel') === 'open'

  const allEvaluationsCount = reviewProcess.currentAccessEvaluations.totalCount ?? 0
  const publishedEvaluationsCount = reviewProcess.currentAccessPublishedEvaluations.totalCount ?? 0
  const pendingEvaluationsCount = allEvaluationsCount - publishedEvaluationsCount

  const isCompleted = pendingEvaluationsCount === 0 || reviewProcess.status === 'finished'

  const onClick = () => setSearchParams({ myReviewsPanel: 'open' })

  if (allEvaluationsCount === 0) return null

  return (
    <Box minWidth={minWidth} width={minWidth}>
      <Card onClick={onClick}>
        <Card.Title
          size="small"
          action={
            !isCompleted && (
              <Tag leftItem="circle" inline capitalize type="tangerine">
                {i18n.t('performance_process.overview.tasks.pending_tasks', {
                  count: pendingEvaluationsCount,
                })}
              </Tag>
            )
          }
        >
          {i18n.t('performance_process.overview.tasks.reviews.title')}
        </Card.Title>
        <Card.Content>
          <Box gap="s16" width="full" flexGrow justifyContent="spaceBetween">
            <Text.Normal color="grey1000">
              {i18n.t('performance_process.overview.tasks.reviews.description')}
            </Text.Normal>
            <Button onClick={onClick} type="secondary">
              {isCompleted
                ? i18n.t('performance_process.overview.tasks.view_all')
                : i18n.t('performance_process.overview.tasks.reviews.action')}
            </Button>
          </Box>
        </Card.Content>
      </Card>

      <Sidepanel
        open={isSidepanelOpen}
        onClose={() => setSearchParams({})}
        width="wideXL"
        title={i18n.t('performance_process.reviews.completed_reviews')}
      >
        <MyReviews />
      </Sidepanel>
    </Box>
  )
}
